import styled from 'styled-components';

export { PublishStatusCircle } from 'components/PublicationStatusMarkets/styles';

export const PublishStatusStyle = styled.span`
  font-weight: bold;
  font-size: 8px;
  position: absolute;
  left: 15px;
  white-space: nowrap;
  color: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.white']
    : props.theme['color.text.body']};
`;

export const HollowCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  background: ${(props) => props.theme['color.redLight']};
  color: white;
  overflow: hidden;

  &::before {
    content: "!";
    display: inline-block;
    font-size: 12px;
    font-weight: bolder;
  }
`;
